var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "watchlater-list" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "watchlater-list-summary" }, [
          _vm._v("共 " + _vm._s(_vm.filteredCards.length) + " 个"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search" },
          [
            _c("TextBox", {
              attrs: { linear: "", placeholder: "搜索" },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "operation",
            attrs: {
              target: "_blank",
              href: "https://www.bilibili.com/medialist/play/watchlater",
            },
          },
          [
            _c(
              "VButton",
              {
                staticClass: "round-button",
                attrs: { title: "播放全部", round: "" },
              },
              [_c("VIcon", { attrs: { icon: "mdi-play", size: 18 } })],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "operation",
            attrs: {
              target: "_blank",
              href: "https://www.bilibili.com/watchlater/#/list",
            },
          },
          [
            _c(
              "VButton",
              {
                staticClass: "round-button",
                attrs: { title: "查看更多", round: "" },
              },
              [
                _c("VIcon", {
                  attrs: { icon: "mdi-dots-horizontal", size: 18 },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("VLoading")
        : !_vm.loading && _vm.cards.length === 0
        ? _c("VEmpty")
        : _c(
            "transition-group",
            {
              staticClass: "watchlater-list-content",
              attrs: { name: "cards", tag: "div" },
            },
            _vm._l(_vm.filteredCards, function (card, index) {
              return _c(
                "div",
                { key: card.aid, staticClass: "watchlater-card" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "watchlater-cover-container",
                      attrs: { target: "_blank", href: card.href },
                    },
                    [
                      _c("DpiImage", {
                        staticClass: "cover",
                        attrs: {
                          src: card.coverUrl,
                          size: { width: 130, height: 85 },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "floating remove",
                          attrs: { title: "移除" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.remove(card.aid, index)
                            },
                          },
                        },
                        [
                          _c("VIcon", {
                            attrs: { icon: "mdi-close", size: 16 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "floating duration" }, [
                        _vm._v(_vm._s(card.durationText)),
                      ]),
                      _vm._v(" "),
                      card.totalPages > 1
                        ? _c("div", { staticClass: "floating pages" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(card.currentPage) +
                                "P / " +
                                _vm._s(card.totalPages) +
                                "P\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      card.percent
                        ? _c("div", {
                            staticClass: "progress",
                            style: { width: card.percent * 100 + "%" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "title",
                      attrs: {
                        target: "_blank",
                        href: card.href,
                        title: card.title,
                      },
                    },
                    [_vm._v(_vm._s(card.title))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c(
                      "a",
                      {
                        staticClass: "up",
                        attrs: {
                          target: "_blank",
                          href: "https://space.bilibili.com/" + card.upID,
                          title: card.upName,
                        },
                      },
                      [
                        _c("DpiImage", {
                          staticClass: "face",
                          attrs: { src: card.upFaceUrl, size: 20 },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(card.upName)),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    card.complete
                      ? _c("div", { staticClass: "viewed" }, [_vm._v("已观看")])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }